const getAllCheckBoxes = () => {
  const checkedItems = document.querySelectorAll('#checked-items');
  const arrayLikeStructure = [...checkedItems];
  return arrayLikeStructure;
};

export default getAllCheckBoxes;
